import styled from "styled-components";
import NavItem from "../../../bootstrap/NavItem";
import Ul from "../../../bootstrap/Ul";
import { Color } from "../../../color";

export const Container = styled.div`
  padding-right: 20px;
  @media (max-width: 922px) {
    padding-right: 0px;
  }
`;

export const CheckBoxUl = styled(Ul)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
`;

// Start range slider styles
export const Range = styled.div`
  text-align: left;
  background: white;
  border: 1px solid #eef2f5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
`;

export const Form = styled.form`
  padding: 35px 10px 15px 10px;
  
  .input-range__slider {
    background: white;
    border: 2.5px solid ${props => props.activeColor || Color};
    width: 16px;
    height: 16px;
    margin-top: -10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  }
  
  .input-range__track--active {
    background: ${props => props.activeColor || Color};
    height: 4px;
  }
  
  .input-range__track--background {
    background: #e2e8f0;
    height: 4px;
  }
  
  .input-range__label-container {
    background: ${props => props.activeColor || Color};
    color: white;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
  }
  
  .input-range__label--max,
  .input-range__label--min {
    display: none;
  }
`;

export const Text = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13.5px;
  font-weight: 700;
  color: #1e293b;
  
  span:last-child {
    font-size: 12px;
    color: #64748b;
    font-weight: 600;
    transition: color 0.2s;
    &:hover {
      color: ${props => props.activeColor || Color};
    }
  }
`;

export const Card = styled.div`
  background: white;
  border: 1px solid #eef2f5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
`;

export const InnerCard = styled.div`
  font-size: 14px;
`;

export const CommonNavItem = styled(NavItem)`
  display: inline-block;
  padding: 0;
  margin: 0;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
`;

export const CommonLabel = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: #f1f5f9;
  color: #475569;
  border: 1.5px solid #e2e8f0;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  
  &:hover {
    border-color: ${props => props.activeColor || Color};
    color: ${props => props.activeColor || Color};
    background: #f8fafc;
  }

  /* When checkbox is checked, style label sibling */
  ${Input}:checked + & {
    background: ${props => props.activeColor || Color};
    color: white;
    border-color: ${props => props.activeColor || Color};
  }
`;

export const Header = styled.h5`
  text-align: left;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  color: #64748b;
  letter-spacing: 0.8px;
  margin-top: 0;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  
  &:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 12px;
    background: ${props => props.activeColor || Color};
    margin-right: 8px;
    border-radius: 2px;
  }
`;

export const Advertisement = styled.div`
  padding: 20px 0px;
  display: none;
`;

export const RightWrapper = styled.div`
  margin-left: 15px;
  @media (max-width: 768px) {
    margin: 0;
  }
`;
